import { Controller } from 'stimulus'
import { fitIcons } from './stripe_payment_method_icons_layout'

export default class extends Controller {
  static targets = ['list', 'icons', 'more']

  connect() {
    this.refresh()
    this.resizeObserver = new ResizeObserver(() => this.fit())
    this.resizeObserver.observe(this.listTarget)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  refresh() {
    const types = JSON.parse(this.element.dataset.stripePaymentMethods)
    const icons = [...this.iconsTarget.content.children]
      .filter((icon) => types.includes(icon.dataset.paymentMethodType))
      .map((icon) => icon.cloneNode(true))

    this.hasMoreMethods = types.some(
      (type) => !icons.some((icon) => icon.dataset.paymentMethodType === type)
    )
    this.listTarget.replaceChildren(...icons, this.moreTarget)
    this.fit()
  }

  fit() {
    const width = this.listTarget.getBoundingClientRect().width
    if (!width) return // ResizeObserver retries when a hidden processor tile becomes visible.

    const icons = [
      ...this.listTarget.querySelectorAll('[data-payment-method-type]'),
    ]
    icons.forEach((icon) => {
      icon.classList.remove('hidden')
    })
    this.moreTarget.classList.remove('hidden')

    const { count, more } = fitIcons(
      icons.map((icon) => icon.getBoundingClientRect().width),
      width,
      parseFloat(getComputedStyle(this.listTarget).columnGap) || 0,
      this.moreTarget.getBoundingClientRect().width,
      this.hasMoreMethods
    )
    icons.forEach((icon, index) => {
      icon.classList.toggle('hidden', index >= count)
    })
    this.moreTarget.classList.toggle('hidden', !more)
  }
}
